var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"post-clickable-hashtag",class:{ active : _vm.isSelected(_vm.tag) },on:{"click":function($event){return _vm.handleClick()}}},[_vm._v(" #"+_vm._s(_vm.tag.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }